<div class="flex flex-col max-h-[85vh]">
  <!-- Cabecera -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 border-b border-gray-200 dark:border-gray-700">
    <!-- Título + nombre del socio (el nombre parte de línea si es largo) -->
    <div class="flex items-start gap-2 min-w-0">
      <mat-icon class="text-primary shrink-0" svgIcon="heroicons_outline:document-text"></mat-icon>
      <div class="min-w-0">
        <h2 class="text-lg font-semibold leading-6">{{ 'DOCUMENT_GENERATE.OPEN_ITEMS_MODAL.TITLE' | t }}</h2>
        <span class="text-sm text-secondary break-words">
          <b>{{ dialogData.customerCode }}</b> - {{ dialogData.customerName }}
        </span>
      </div>
    </div>
    <!-- Acciones: en escritorio a la derecha, en móvil debajo del nombre -->
    <div class="flex flex-wrap items-center gap-2 sm:shrink-0">
      <button mat-stroked-button color="primary" type="button" (click)="openExport()" [matTooltip]="'GENERAL.EXPORT' | t">
        <mat-icon class="icon-size-5" svgIcon="heroicons_outline:document-arrow-down"></mat-icon>
        <span class="ml-2">{{ 'GENERAL.EXPORT' | t }}</span>
      </button>
      <button mat-stroked-button color="warn" type="button" (click)="downloadPdf()"
        [disabled]="isPdfDownloadDisabled"
        [matTooltip]="(isPdfDownloadDisabled ? 'DOCUMENT_GENERATE.OPEN_ITEMS_MODAL.NO_DATA_TOOLTIP' : 'DOCUMENT_GENERATE.OPEN_ITEMS_MODAL.DOWNLOAD_PDF') | t">
        <mat-icon class="icon-size-5" svgIcon="heroicons_outline:document"></mat-icon>
        <span class="ml-2">{{ 'DOCUMENT_GENERATE.OPEN_ITEMS_MODAL.DOWNLOAD_PDF' | t }}</span>
      </button>
      <button mat-icon-button type="button" (click)="close()" [matTooltip]="'GENERAL.CLOSE' | t">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Contenido con scroll vertical -->
  <div class="flex-1 overflow-y-auto p-4">
    <!-- Tarjetas KPI -->
    <div *ngIf="summary" class="grid grid-cols-2 gap-2 sm:gap-3 md:grid-cols-4 mb-4">
      <div class="flex flex-col p-2 sm:p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
        <span class="text-xs text-secondary mb-1">{{ 'DOCUMENT_GENERATE.OPEN_ITEMS_MODAL.TOTAL_ITEMS' | t }}</span>
        <span class="text-lg sm:text-xl font-bold text-blue-600 dark:text-blue-400">{{ summary.totalItems }}</span>
      </div>
      <div class="flex flex-col p-2 sm:p-3 bg-green-50 dark:bg-green-900/20 rounded-lg">
        <span class="text-xs text-secondary mb-1">{{ 'DOCUMENT_GENERATE.OPEN_ITEMS_MODAL.TOTAL_PAID' | t }}</span>
        <span class="text-lg sm:text-xl font-bold text-green-600 dark:text-green-400 truncate">{{ currencySymbol }} {{ summary.totalAmount | decimalFormat }}</span>
      </div>
      <div class="flex flex-col p-2 sm:p-3 bg-orange-50 dark:bg-orange-900/20 rounded-lg">
        <span class="text-xs text-secondary mb-1">{{ 'DOCUMENT_GENERATE.OPEN_ITEMS_MODAL.TOTAL_BALANCE' | t }}</span>
        <span class="text-lg sm:text-xl font-bold text-orange-600 dark:text-orange-400 truncate">{{ currencySymbol }} {{ summary.totalBalance | decimalFormat }}</span>
      </div>
      <div class="flex flex-col p-2 sm:p-3 bg-red-50 dark:bg-red-900/20 rounded-lg">
        <span class="text-xs text-secondary mb-1">{{ 'DOCUMENT_GENERATE.OPEN_ITEMS_MODAL.OVERDUE_ITEMS' | t }}</span>
        <span class="text-lg sm:text-xl font-bold text-red-600 dark:text-red-400">{{ summary.totalExpired }}</span>
      </div>
    </div>

    <!-- Grilla -->
    <app-smart-grid
      [data]="data"
      [columnDefs]="columnDefs"
      [config]="gridConfig"
      [loading]="loading"
      [totalRecords]="totalItems"
      (sortChanged)="changeSort($event)"
      (pageChanged)="changePage($event)">
    </app-smart-grid>
  </div>
</div>
